import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
// import Products from './components/Products';

import { Button, FormControlLabel, MenuItem, Radio, Typography, Checkbox, Toolbar, AppBar } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import classNames from 'classnames';
import $ from "jquery";
import { withAlert } from 'react-alert';
// import PropTypes from 'prop-types';
import FileUpload from '@material-ui/icons/FileUpload';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import AddIcon from '@material-ui/icons/Add';
import ReactDOM from 'react-dom';
import Select from 'react-select';

import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import Loader from "other-components/loader/loader";

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    layoutRoot: {},
    // layoutToolbar: {
    //     padding: 0
    // },
    // tabsRoot: {
    //     height: 64
    // },
    // tabRoot: {
    //     height: 64
    // },
    // root: {
    //     width: '100%',
    // },
    // heading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     flexBasis: '33.33%',
    //     flexShrink: 0,
    // },
    // secondaryHeading: {
    //     fontSize: theme.typography.pxToRem(15),
    //     color: theme.palette.text.secondary,
    // }
});


var id = null;
var acc_type = null;
var acc_type_name = null;
var acc_ref_no = null;
var acc_category = null;
var description = null;
var is_active = null;

class AccountCategory extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            accountTypes: [],
            openComposeDialog: false,
            loading: true,
            isActive: true,
            isActiveEdit: false,
            isTableAdd: false,
            editAccountType: false,
            editCatName: false,
            brokerObj: null,
            accountType: '',
            accountTypeEdit: '',
            accountTypeValue: '',
            accountTypeEditValue: '',
            isNew: false,
            value: ''
        };
        // alert(this.props.ref_no)
        this.loadData();
        this.loadAccountTypes();
        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
    }

    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
        this.clearValue()
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
        this.clearValue();
    };


    handleCloseDelete = () => {
        this.setState({ delete: false });
        this.clearValue();
    };


    checkAccountTypeIsAvailable(acc_type) {
        const categoryObj = {
            id: acc_type
        }
        // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountByCategoryId', categoryObj)
        axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountByCategoryId', categoryObj)
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                // alert(response.data.count[0].COUNT)
                let count = response.data.count[0].COUNT;
                if (count == 0) {
                    this.setState({
                        editAccountType: false,
                        editCatName: false,

                    })

                } else {
                    this.setState({
                        editAccountType: true,
                        editCatName: true
                    })
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    onEdit = (model) => {

        var acc_type;
        if (this.state.accountTypeEditValue.value == null) {
            // alert("1"+this.state.accountTypeEditValue.value)
            acc_type = this.state.accountTypeEditValue;
            this.setState({
                isNew: false
            })
            this.editAccountCategory(model, acc_type, false);
        } else {
            // alert("2"+this.state.accountTypeEditValue.value)
            acc_type = this.state.accountTypeEditValue.value;
            this.setState({
                isNew: true
            })
            this.editAccountCategory(model, acc_type, true);
        }


        // const categoryObj = {
        //     id: acc_type
        // }
        // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountByCategoryId', categoryObj)
        //     // axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountByCategoryId', categoryObj)
        //     .then(response => {
        //         // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
        //         // alert(response.data.count[0].COUNT)
        //         let count = response.data.count[0].COUNT;
        //         let ref_no = model.acc_ref_no
        //         if (count == 0) {
        //             if (this.state.accountTypeEditValue.value == null) {
        //                 ref_no = this.state.accountTypeEditValue;
        //             } else {
        //                 ref_no = this.state.accountTypeEditValue.value;
        // }


        //     } else {
        //         this.props.alert.error("can't edit because already have ledger record from this category");
        //     }

        // }).catch(function (error) {
        //     console.log("err " + error);
        //     console.log("No internet connection or Internal error");
        //     // alert("No internet connection or Internal error");
        // });

    };

    // edit employee profesional qulification details
    editAccountCategory(model, acc_type, isNew) {
        var accountCategoryEditObj;
        // alert("as" + isNew)
        if (isNew) {
            accountCategoryEditObj = {
                id: model.id,
                acc_type: acc_type,
                // acc_ref_no: model.acc_ref_no,
                acc_ref_no: acc_type,
                acc_category: model.acc_category,
                description: model.description,
                is_active: this.state.isActiveEdit,
                isNew: isNew
            }
        } else {
            // alert(model.acc_ref_no)
            accountCategoryEditObj = {
                id: model.id,
                acc_type: acc_type,
                acc_ref_no: model.acc_ref_no,
                acc_category: model.acc_category,
                description: model.description,
                is_active: this.state.isActiveEdit,
                isNew: isNew
            }
        }


        console.log("adada=== " + JSON.stringify(accountCategoryEditObj))
        // axios.post('http://localhost:5009/accountCategory/updateAccountCategory', accountCategoryEditObj)
        axios.post(window.accountServer + '/accountCategory/updateAccountCategory', accountCategoryEditObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("Account Category Details Updated Successfully.");
                    this.handleCloseEdit();
                    this.loadData();
                    // this.form.reset();
                    this.clearValue();
                    this.setState({ openComposeDialog: false });
                } else {
                    // alert('Ivalid Credentials');
                    this.props.alert.error("Error In Account Category Update.");
                }

            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

    }


    handleAcountType = (selectedOption) => {
        // alert(selectedOption.value)
        this.setState({
            accountType: selectedOption
            // ,
            // accountTypeValue: selectedOption.value
        });

    }

    handleAcountTypeEdit = (selectedOption) => {
        // alert(selectedOption.value)
        this.setState({
            // accountTypeEdit: selectedOption.value,
            accountTypeEditValue: selectedOption
        });

    }

    handleCheckSuspendChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckSuspendChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    // load employee gender into drop-down
    loadAccountTypes() {
        var accountTypes = [];
        // axios.get('http://localhost:5009/accountType/getAccountTypes')
        axios.get(window.accountServer + '/accountType/getAccountTypes')
            .then(response => {
                // console.log("rrrrrrrrrrrrrrrrrrrrrrrrrr"+response.data.accountTypes);
                for (let i = 0; i < response.data.accountTypes.length; i++) {

                    accountTypes.push({
                        value: response.data.accountTypes[i].ID_ACCOUNT_TYPE,
                        label: response.data.accountTypes[i].NAME
                    });
                }
                this.setState({ accountTypes: accountTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadData() {
        var resObj;

        var brokerObjArray = []
        var length;
        var lastDate;
        // axios.get('http://localhost:5009/accountCategory/getAccountCategories')
        axios.get(window.accountServer + '/accountCategory/getAccountCategories')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.accountCategories;
                    this.appendToTable(resObj)
                    // this.appendToTable(brokerObjArray)

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.handleCloseEdit();
    }


    appendToTable(accCategoryObj) {

        console.log(accCategoryObj)
        var data = [];
        var active;
        for (var i = 0; i < accCategoryObj.length; i++) {
            if (accCategoryObj[i].IS_ACTIVE == 1) {
                active = 'Active'
            } else {
                active = 'Inactive'

            }
            data.push({
                id: accCategoryObj[i].ID_ACCOUNT_CATEGORY,
                acc_type: accCategoryObj[i].ID_ACCOUNT_TYPE,
                acc_type_name: accCategoryObj[i].ACCOUNT_TYPE_NAME,
                acc_ref_no: accCategoryObj[i].REFERENCE_NO,
                acc_category: accCategoryObj[i].NAME,
                description: accCategoryObj[i].DESCRIPTION,
                is_active: accCategoryObj[i].IS_ACTIVE,
                active: active
            });

        }

        this.setState({ data: data });
        this.setState({ loading: false });
    }



    onSubmit = (model) => {

        if ("" == this.state.accountType || null == this.state.accountType || undefined == this.state.accountType) {
            this.props.alert.error("Please Select Account Type !");
        } else {
            this.saveAccountCategory(model);
        }

    };

    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }



    saveAccountCategory(model) {

        const accountCategoryObj = {
            acc_type: this.state.accountType.value,
            acc_ref_no: this.state.accountType.value,
            acc_category: model.acc_category,
            description: model.description,
            is_active: this.state.isActive
        }



        // axios.post('http://localhost:5009/accountCategory/createAcountCategory', accountCategoryObj)
        axios.post(window.accountServer + '/accountCategory/createAcountCategory', accountCategoryObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.handleCloseEdit();
                    this.props.alert.success("Account Category Details Update Successfully.");
                    this.loadData();
                    this.form.reset();
                    this.clearValue();
                    this.setState({ openComposeDialog: false });
                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })


    }

    clearValue = () => {
        // alert()
        this.form.reset();
        this.setState({ accountType: '' });
        // this.form.reset();
    }
    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <React.Fragment>
                    <div>
                        <Toolbar className="flex w-full pt-24 px-12 ml-1920">
                            <h2 className="w-full subtitle-color">
                                Account Category View
                            </h2>
                            <div className="px-12">
                                <Button
                                    className="w-200"
                                    type="button"
                                    variant="raised"
                                    color="secondary"
                                    onClick={(ev) => {
                                        this.openNewCustomerDialog();
                                    }}
                                >
                                    Add
                                </Button>
                            </div>
                            <div className="px-12">
                                <Button
                                    variant="raised"
                                    color="default"
                                >
                                    Help
                            </Button>
                            </div>
                        </Toolbar>

                        <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">
                            <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                <Toolbar className="flex w-full">
                                    <Typography className="w-full" variant="subheading" color="inherit">
                                        Account Category
                          </Typography>
                                    <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>

                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center"
                            >

                                <div className="w-full p-16 mt-8 pr-24 " >
                                    <div >
                                        <h3 className="mt-4">Account Category</h3>
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/5   mt-16 ">
                                        Account Type
                                <Select
                                            className="w-full "
                                            style={{ margintop: '200px' }}
                                            name="form-field-name"
                                            placeholder="Select Account Type"

                                            value={this.state.accountType}
                                            onChange={this.handleAcountType}
                                            options={this.state.accountTypes}
                                        />
                                    </div>
                                    {/* <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24 mt-8"
                                        type="text"
                                        name="acc_ref_no"
                                        label="Account Category Ref. No"
                                        required
                                        validations={{
                                            maxLength: 50
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}

                                    /> */}
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24 justify-end"
                                        type="text"
                                        name="acc_category"
                                        label="Account Category"
                                        required
                                        validations={{
                                            maxLength: 150
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}
                                    />


                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 pr-24"
                                        type="text"
                                        name="description"
                                        label="Description"
                                        validations={{
                                            maxLength: 250
                                        }}
                                        validationErrors={{

                                            maxLength: 'This is not a valid'
                                        }}



                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.isActive}
                                                onChange={this.handleCheckActiveChange('isActive')}
                                                color="primary"
                                                disabled
                                            // checked
                                            />
                                        }
                                        label="Active"
                                    />

                                    <div className="w-full md:w-2/3">

                                    </div>

                                    <div className="w-full md:w-1/3 float-right mb-16">

                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                            Save
                                    </Button>

                                        <Button variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8 " onClick={this.clearValue}>
                                            Clear
                                    </Button>
                                        <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ml-8 mr-8" onClick={this.closeNewCustomerDialog}>
                                            Close
                                    </Button>
                                    </div>
                                </div>
                            </Formsy>

                        </Dialog>

                        <div className="p-20">
                            <div>
                                <div className="flex flex-wrap -mx-3 mb-12">
                                    <div className="w-full md:w-2/3"></div>
                                    {/* <div className="w-full md:w-1/3">
                                
                                <TextField
                                    placeholder="Search for anything"
                                    className="pl-16"
                                    fullWidth
                                    value={this.state.value}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={this.handleSearchAny}
                                />
                                {/* <Icon className="-mb-4 -mr-4" color="action">search</Icon> */}
                                    {/* </div> */}
                                </div>

                                <div class="flex h-auto mt-4">

                                    <div class="w-full bg-white h-auto">
                                        <ReactTable
                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    onClick: (e, handleOriginal) => {

                                                    }
                                                }
                                            }}
                                            data={this.state.data}
                                            columns={[
                                                {
                                                    Header: "Account Type",
                                                    accessor: "acc_type_name",
                                                    maxWidth: 300,
                                                    className: "justify-start",

                                                },
                                                {
                                                    Header: "Account Category Ref No",
                                                    accessor: "acc_ref_no",
                                                    maxWidth: 300,
                                                    className: "justify-start",

                                                },
                                                {
                                                    Header: "Account Category",
                                                    accessor: "acc_category",
                                                    maxWidth: 300,

                                                    className: "justify-start",
                                                },
                                                {
                                                    Header: "Status",
                                                    accessor: "status",
                                                    maxWidth: 200,
                                                    className: "justify-center",
                                                    Cell: row => (

                                                        <div className="flex items-center">
                                                            <Icon
                                                                className={row.original.active === 'Active' ? 'text-green-light'
                                                                    : row.original.active === 'Inactive' ? 'text-red-light'
                                                                        : 'text-orange-light'}
                                                                title={row.original.active === 'Active' ? 'Active'
                                                                    : row.original.active === 'Inactive' ? 'Inactive'
                                                                        : 'text-orange-light'}
                                                            >
                                                                {row.original.active === 'Active' ? 'check_circle'
                                                                    : row.original.active === 'Inactive' ? `cancel`
                                                                        : 'Other'}
                                                            </Icon>

                                                        </div>
                                                    )

                                                },
                                                {
                                                    Header: "Action",
                                                    className: "justify-center",
                                                    maxWidth: 100,
                                                    // accessor: "su",
                                                    width: 128,
                                                    Cell: row => (
                                                        <div className="flex items-center w-8 h-8">
                                                            <IconButton

                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        id = row.original.id;
                                                                        acc_type = row.original.acc_type;
                                                                        acc_type_name = row.original.acc_type_name;
                                                                        acc_ref_no = row.original.acc_ref_no;
                                                                        acc_category = row.original.acc_category;
                                                                        description = row.original.description;
                                                                        is_active = row.original.is_active;
                                                                        this.setState({
                                                                            // accountTypeEdit: row.original.acc_type,
                                                                            accountTypeEditValue: row.original.acc_type
                                                                        });
                                                                        this.setState({ isActiveEdit: row.original.is_active });
                                                                        this.checkAccountTypeIsAvailable(id)

                                                                        this.setState({ edit: true });
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-blue" title="Edit">mode_edit</Icon>
                                                            </IconButton>

                                                            {/* /////me */}
                                                            <Dialog className={classNames(classes.root, "z-10")}

                                                                open={this.state.edit}
                                                                onClose={this.handleCloseEdit}
                                                                aria-labelledby="form-dialog-title"
                                                            >
                                                                <Formsy
                                                                    onValidSubmit={this.onEdit}
                                                                    onValid={this.enableButtonEdit}
                                                                    onInvalid={this.disableButtonEdit}
                                                                    ref={(form) => this.form = form}
                                                                    className="flex flex-col justify-center"
                                                                >
                                                                    <DialogTitle id="form-dialog-title">Edit Account Category Details</DialogTitle>
                                                                    <DialogContent className="flex flex-wrap">

                                                                        <div className="w-full">

                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="id"
                                                                                value={id}
                                                                            />

                                                                            <Select
                                                                                className="w-1/2"
                                                                                name="form-field-name"
                                                                                placeholder="Select Account Type"
                                                                                disabled={this.state.editAccountType}
                                                                                value={this.state.accountTypeEditValue}
                                                                                onChange={this.handleAcountTypeEdit}
                                                                                options={this.state.accountTypes}

                                                                            />
                                                                            
                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="acc_ref_no"
                                                                                label="Account Category Code"
                                                                                disabled={true}
                                                                                value={acc_ref_no}

                                                                            />

                                                                           

                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16 account-catrgory-form-margin"
                                                                                type="text"
                                                                                name="acc_category"
                                                                                label="Account Category"
                                                                                // disabled={true}
                                                                                disabled={this.state.editCatName}
                                                                                value={acc_category}

                                                                            />
                                                                           


                                                                        </div>
                                                                        <div className="w-full">


                                                                            <TextFieldFormsy
                                                                                className="w-1/2 mt-16"
                                                                                type="text"
                                                                                name="description"
                                                                                label="Description"
                                                                                value={description}

                                                                            />
                                                                            <FormControlLabel
                                                                                className=" mt-16 ml-4 "
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.isActiveEdit}
                                                                                        onChange={this.handleCheckActiveChanges('isActiveEdit')}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Active"
                                                                            />
                                                                        </div>

                                                                        <div className="w-full">

                                                                        </div>

                                                                    </DialogContent>
                                                                    <DialogActions>

                                                                          <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8 ">
                                                                            Update
                                                                        </Button>
                                                                        
                                                                        <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                                                            Close
                                                                        </Button>                                                                      
                                                                    </DialogActions>
                                                                </Formsy>
                                                            </Dialog>


                                                            {/* /////me */}

                                                            {/* <IconButton
                                                            onClick={(e) => {
                                                            if (row) {

                                                                // updateTradeId = row.original.superTradeId;
                                                                // updateTradeName = row.original.superTradeName;
                                                                // isActive = row.original.isActive;
                                                                this.setState({ delete: true });
                                                                id = row.original.id;
                                                                // alert(id);


                                                            }
                                                            }}

                                                            >
                                                            <Icon className="text-red-light">delete</Icon>
                                                            </IconButton> */}


                                                            {/* /////me */}

                                                            <Dialog
                                                                open={this.state.delete}
                                                                onClose={this.handleClose}
                                                                aria-labelledby="form-dialog-title"
                                                            >
                                                                <DialogTitle id="form-dialog-title">Delete Profesional Qualification</DialogTitle>
                                                                <DialogContent>

                                                                    <div>

                                                                        <Formsy
                                                                            onValidSubmit={this.onDelete}
                                                                            onValid={this.enableButtonDelete}
                                                                            onInvalid={this.disableButtonDelete}
                                                                            ref={(form) => this.form = form}
                                                                            className="flex flex-col justify-center"
                                                                        >
                                                                            <TextFieldFormsy
                                                                                type="hidden"
                                                                                name="id"
                                                                                value={id}
                                                                            />

                                                                            <DialogActions>
                                                                                <Button onClick={this.handleCloseDelete} color="primary">
                                                                                    Cancel
                                                                        </Button>

                                                                                <Button
                                                                                    type="submit"
                                                                                    variant="raised"
                                                                                    color="primary"
                                                                                    className="mx-auto mt-16 pb-15"
                                                                                    aria-label="Edit"
                                                                                // disabled={!canEdit}
                                                                                >
                                                                                    Change
                                                                        </Button>
                                                                            </DialogActions>
                                                                        </Formsy>
                                                                    </div>
                                                                </DialogContent>


                                                            </Dialog>

                                                            {/* ///// */}


                                                        </div>
                                                    )
                                                }

                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(AccountCategory));


// WEBPACK FOOTER //
// ./src/main/content/accounting/accountCategory/AccountCategory.js